import React from "react";
import { Link } from "react-router-dom";

const OrderCard = ({
  orderId,
  productName,
  productImage,
  productBy,
  price,
  quantity,
  status,
  deliveryDate,
  trackingId,
}) => {
  return (
    <div className="order-card">
      {/* Product Image */}
      <div className="order-card-image">
        <img src={productImage} alt={productName} />
      </div>

      {/* Order Details */}
      <div className="order-card-details">
        {/* Header */}
        <div className="order-header">
          <p className="order-id">Order #{orderId}</p>
          <Link to={`/my-orders/my-order-detail/${orderId}`} className="order-link">
            View order detail
          </Link>
        </div>

        {/* Product Info */}
        <h2 className="order-title">{productName}</h2>
        <p className="order-productby">Product by {productBy}</p>
        <p className="order-price">{price} USD</p>

        {/* Footer Extra Info */}
        <div className="order-extra">
          <p>
            Quantity : <span>{quantity}</span>
          </p>
          <p>
            Status :{" "}
            <span
              className={`status ${
                status.toLowerCase() === "confirmed" ? "status-confirmed" : ""
              }`}
            >
              {status}
            </span>
          </p>
          <p>
            Delivery Expected by : <span>{deliveryDate}</span>
          </p>
          <p>
            Tracking ID : <span>{trackingId}</span>
            <br />
            <Link to={`/my-orders/track-orders/${trackingId}`} className="order-link">
              Track Order
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
